<script setup lang="ts">
const CountUp = defineAsyncComponent(() => import('vue-countup-v3'));

const imgs = [
    { path: '/img/user1.jpg' },
    { path: '/img/user2.jpg' },
    { path: '/img/user3.jpg' },
    { path: '/img/user4.jpg' },
]
</script>

<template>
    <div class="gridClass flex items-center gap-2 pr-5 -mt-2">
        <div class="flex items-center gap-1 [&>*]:mr-[-20px]">
        <div class="w-10 h-10 shadow-sm border-[2px] border-white rounded-full overflow-hidden" v-for="i in imgs">
            <NuxtImg 
                :src="i.path"
                format="webp"
                class="w-full h-full object-cover"
                alt="navatel user"
            />
        </div>
        </div>
        <div class="flex flex-col justify-center">
        <span class="text-xl text-[#111C2D] font-semibold">
            <span class="text-2xl">+</span>
            <ClientOnly>
                <CountUp 
                    :end-val="8236"
                    :duration="5"
                    class="inline"
                />
            </ClientOnly>
        </span>
        <span class="text-sm text-[#215897] leading-[.25rem] mb-3">کاربر فعال روزانه</span>
        </div>
    </div>
</template>
